var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09076 12.1815C2.72683 12.1815 0 9.45468 0 6.09076C0 2.72683 2.72683 0 6.09076 0C9.45468 0 12.1815 2.72683 12.1815 6.09076C12.1815 9.45468 9.45468 12.1815 6.09076 12.1815ZM6.09076 11.4506C7.51228 11.4506 8.87558 10.8859 9.88075 9.88075C10.8859 8.87558 11.4506 7.51228 11.4506 6.09076C11.4506 4.66923 10.8859 3.30593 9.88075 2.30076C8.87558 1.29559 7.51228 0.730891 6.09076 0.730891C4.66923 0.730891 3.30593 1.29559 2.30076 2.30076C1.29559 3.30593 0.730891 4.66923 0.730891 6.09076C0.730891 7.51228 1.29559 8.87558 2.30076 9.88075C3.30593 10.8859 4.66923 11.4506 6.09076 11.4506ZM5.37692 7.64877L8.91504 4.11126L9.43154 4.62837L5.80754 8.25237C5.69332 8.36655 5.53842 8.43069 5.37692 8.43069C5.21541 8.43069 5.06052 8.36655 4.9463 8.25237L3.04538 6.35022L3.56248 5.83312L5.37753 7.64816L5.37692 7.64877Z",
    fill: "#3A61FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.69591c9aee6057f38148e9e79e9bf787.svg";
export { ForwardRef as ReactComponent };